<template>
    <div>
      <div class="u-time">
     
      <div class="f-dfa"
           @click="initReportList">
        <div class="bb">
          <van-icon name="todo-list-o"
                    size="16px" />
        </div>
        报表
      </div>
      <van-popup v-model="show2"
               position="bottom"
               class="popup-list">
      <div class="itembox"
           v-for="(item,index) in relist"
           :key="index">
        <div class="item"
             v-for="(item2,index2) in item.list"
             :key="index2"
             @click='jumpUrl(item2.REPORT_URL)'>{{item2.NAME}}</div>
      </div>

    </van-popup>
    </div>
        <ul class="list" v-if="!qx">
            <li>
                <div class="sort">序号</div>
                <div class="name">单位名称  </div>
                <div class="num_1">部门领导空缺</div>
                <div class="num_2">岗位上级空缺</div>
                <div class="detail"></div>
            </li>
            <li v-for="(item,index) in list" :key="item.id">
                <div class="sort">{{index + 1}}</div>
                <div class="name">{{item.org}}</div>
                <div class="num_1">{{item.noName1Deps.length}}</div>
                <div class="num_2">{{item.noName2Deps.length}}</div>
                <div class="detail" @click="goDetail(item)">详情
                    <img src="../assets/hr/arrow.png" alt="">
                </div>
            </li>
        </ul>
        <div class="remind" v-else>{{this.remind}}</div>
    </div>
</template>

<script>
import api from "@/axios/api";
import { mapGetters, mapActions } from "vuex";
export default {
    computed: {
        ...mapGetters(["token"])
    },
    watch: {
        token: {
            immediate: true,
            handler: function(val) {
                if (val) {
                    this.getJobMatch();
                }
            }
        }
    },
    data() {
        return {
            list: [],
            relist:[],
            show2:false,
            qx:false,
            remind:""
        };
    },
    filters: {
        
    },
    mounted() {
        
           
        //this.getJobMatch();

    },
    methods: {
      initReportList () {
      this.show2 = true;
      api.getListDataItems().then(res => {
        
        this.relist = res
          
      })
      
    },
        getJobMatch() {
            api.getJobMatch().then(res => {
                
                if(res.length == 1 && res[0].org == "暂无权限查看数据，如需查看请联系管理员"){

                    this.qx = true;
                    this.remind = "暂无权限查看数据，如需查看请联系管理员";
                }else {
                    this.list = res
                }
            });
        },
        goDetail(data){
            this.$router.replace({
                path: "/hrReport/hrDetails",
                query: {
                    name: "绩效详情",
                    data: data
                }
            });
        }
        
    }
};
</script>

<style lang="less" scoped>
.f-dfa {
    display: flex;
    align-items: center;
  }
.u-time {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 4vw;
    background: #5584ff;
    color: #fff;
  }
  .date {
    display: flex;
    align-items: center;
    margin: 0 2vw;
  }
  .bb {
    margin-right: 1vw;
  }
  .popup-list {
    padding: 4vw;
    height: 94vw;
    overflow-y: scroll;
    border-radius: 12px 12px 0 0;
    box-sizing: border-box;
  }
  .popup-list .itembox {
    padding: 2vw 0;
    border-bottom: 1px solid #ccc;
    overflow: hidden;
  }
  .popup-list .itembox:last-child {
    border-bottom: none;
  }
  .popup-list .itemname {
    padding: 4vw 2vw 2vw 2vw;
    font-size: 18px;
    font-weight: 700;
    text-align: left;
  }
  .popup-list .item {
    float: left;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 8vw;
    margin: 2vw;
    padding: 2vw 4vw;
    font-size: 16px;
    background: #f1f1f1;
    color: #5f7091;
    border-radius: 60px;
  }
.list{
    background: #fff;
    li:first-child{
        background: #E2EAFE;
        border-bottom:none;
    }
    li{
        display: flex;
        align-items: center;
        min-height: 12.8vw;
        padding: 0 3.2vw;
        text-align: center;
        font-size: 14px;
        border-bottom:1px solid #E0E0E0;
        .sort{
            width: 10vw;
            margin-right: 1vw;
        }
        .name{
            width: 28vw;
        }
        .num_1{
            width: 25vw;
        }
        .num_2{
            width: 25vw;
        }
        .detail{
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 11vw;
            color: #D91A1A;
            img{
                width: 2vw;
                margin-bottom: -0.4vw;
            }
        }
    }
}
.remind{
    margin-top: 40vw;
    color: #ff0000;
}
</style>





// WEBPACK FOOTER //
// src/hrReport/hrList.vue